import React, { useState } from "react";
import APRLoadNoticeView from "../Components/LoadNotice/Views/APRLoadNoticeView";
import { useAppDispatch } from "../../../../store";
import { useParams } from "react-router-dom";
import { generateLoadNoticePdfAPI } from "../quotationApis";
import { Spin } from "antd";
import { svg } from "../../../../Assets/svg";
import ViewPdfModal from "../Components/LoadNotice/ViewPdfModal";
import { CommonConfirmationModal } from "../../../../Components/CommonConfirmationModal";

const LoadNoticeDetails = ({
  data,
  quoteId,
}: {
  data: any;
  quoteId?: string;
}) => {
  console.log("data", data)
  const dispatch = useAppDispatch();
  const loadNotices = data?.load_notice || [];

  const quoteFor = data?.customer_snapshot?.quote_for?.key;
  const isDistributorQuote = quoteFor === "distributor" ? true : false;

  const [pdfData, setPdfData] = useState<any>(null);
  const [pdfLoadingId, setPdfLoadingId] = useState<string | null>(null);

  const [errorModalData, setErrorModalData] = useState<{
    title: string | null;
    message: string | null;
  }>({
    title: null,
    message: null,
  });

  const isAPRCategory = (data?.categories_snapshot ?? []).some(
    (item: any) => item?.slug === "adjustable-pallet-racking-apr",
  );
  const hasLoadNotices = loadNotices && loadNotices.length > 0;
  const hasAdvertisementSign = Number(data?.advertisement_sign) > 0;

  if (!isAPRCategory && !hasAdvertisementSign) {
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-md-3 mb-2">
          <h4 className="fs-5 fw-bold text-black mb-0">Advertisement Sign</h4>
        </div>
        <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white text-center text-muted">
          No advertisement sign added.
        </div>
      </div>
    );
  }

  if (isAPRCategory && !hasLoadNotices && !hasAdvertisementSign) {
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-md-3 mb-2">
          <h4 className="fs-5 fw-bold text-black mb-0">Load Notices</h4>
        </div>
        <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white text-center text-muted">
          No load notices added.
        </div>
      </div>
    );
  }

  return (
    <>
      {isAPRCategory && (
        <>
          {!hasLoadNotices && (
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-md-3 mb-2">
                <h4 className="fs-5 fw-bold text-black mb-0">Load Notices</h4>
              </div>
              <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white text-center text-muted">
                No load notices added.
              </div>
            </div>
          )}
          {loadNotices?.map((loadNotice: any, index: number) => {
        const loadNoticeTitle = `Load Notice ${index + 1}`;

        return (
          <div
            key={loadNotice._id}
            className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white mb-4"
          >
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-start align-items-sm-center mb-3 pb-2 border-bottom">
                <div className="d-flex flex-wrap align-items-start align-items-sm-center gap-2">
                  <div className="fs-6 fw-bold  text-primary">
                    {loadNoticeTitle}
                  </div>
                  {isDistributorQuote && (
                    <div className="fs-6">
                      <span className="fw-semibold text-muted">
                        Use Distributors Details:
                      </span>
                      <span className="ms-1">
                        {loadNotice?.use_distributor_detail ? "Yes" : "No"}
                      </span>
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-link p-0 svg-32"
                  disabled={pdfLoadingId === loadNotice?._id}
                  onClick={() => {
                    setPdfLoadingId(loadNotice?._id);
                    const payload = {
                      quote_id: quoteId as string,
                      load_notice_id: loadNotice?._id,
                    };
                    dispatch(
                      generateLoadNoticePdfAPI({
                        payload,
                        onSuccess: (res: any) => {
                          const blob = new Blob([res], {
                            type: "application/pdf",
                          });
                          const url = window.URL.createObjectURL(blob);
                          setPdfData({
                            url,
                            blob,
                            title: loadNoticeTitle,
                          });
                          setPdfLoadingId(null);
                        },
                        onError: () => {
                          setPdfLoadingId(null);
                        },
                        onMissingDetailsError: (messageData: any) => {
                          if (messageData?.description && messageData.title) {
                            setErrorModalData({
                              title: messageData.title,
                              message: messageData.description,
                            });
                          }
                        },
                      }),
                    );
                  }}
                >
                  {pdfLoadingId === loadNotice?._id ? (
                    <Spin size="small" />
                  ) : (
                    svg?.loadNoticePDF
                  )}
                </button>
              </div>
              <APRLoadNoticeView data={loadNotice} />
            </div>
          </div>
        );
      })}
        </>
      )}
      {/* Advertisement Sign Card */}
      {hasAdvertisementSign && (
        <div className="card border-0 shadow-sm rounded-4 bg-white mb-4">
          <div className="card-body py-3 px-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h6 className="fw-bold mb-0 text-dark fs-6">
              Advertisement Sign
            </h6>
            <div className="fs-6 text-secondary fw-normal">
              Qty:{" "}
              <span className="fw-bold text-dark">{data.advertisement_sign}</span>
            </div>
          </div>
        </div>
      )}

      <ViewPdfModal
        open={pdfData != null}
        pdfData={pdfData}
        onClose={() => {
          if (pdfData?.url) window.URL.revokeObjectURL(pdfData.url);
          setPdfData(null);
        }}
      />

      {errorModalData?.title && (
        <CommonConfirmationModal
          open={errorModalData?.title !== null}
          onClose={() => {
            setErrorModalData({ title: null, message: null });
          }}
          onSuccess={() => setErrorModalData({ title: null, message: null })}
          title={errorModalData?.title || ""}
          subTitle={errorModalData?.message || ""}
          onlyCloseButton={true}
        />
      )}
    </>
  );
};

export default LoadNoticeDetails;
